import { create } from 'twrnc'
import TailwindConfig from '../tailwind.config'

const tw = create(TailwindConfig)

export default tw
